import { twMerge } from "tailwind-merge";

function Pagination({ className, children }) {
  return (
    <nav className={className}>
      <ul className="flex w-full mr-0 min-sm:w-auto min-sm:mr-auto">{children}</ul>
    </nav>
  );
}

Pagination.Link = ({ className, active, children }) => {
  return (
    <li className="flex-1 min-sm:flex-initial">
      <button
        as="a"
        className={twMerge([
          "min-sm:min-w-[40px] shadow-none font-normal flex items-center justify-center border-transparent text-slate-800 min-sm:mr-2 dark:text-slate-300 px-1 min-sm:px-3",
          active && "!box font-medium dark:bg-darkmode-400",
          className,
        ])}
      >
        {children}
      </button>
    </li>
  );
};

export default Pagination;